export const productImage =
  "https://cdn.magicpatterns.com/uploads/tXnUBnAv2EwSSdHTBdNWHB/mockup_franquicia_rentable_final.png";

export const testimonials = [
  {
    initials: "MJ",
    city: "Bogotá",
    quote: "Organicé mi negocio en una tarde. Vendí 8 tortas la primera semana.",
  },
  {
    initials: "CR",
    city: "México",
    quote: "Los 50 Reels me ahorraron meses. Meta Ads ya me trae clientes sin parar.",
  },
  {
    initials: "AP",
    city: "Lima",
    quote: "El catálogo en Canva cambió todo. Vendo por WhatsApp sin hablar.",
  },
];

export const painPoints = [
  { title: "Semanas probando recetas que fracasan", detail: "Materia prima a la basura." },
  { title: "No saber qué precio cobrar", detail: "Vendes barato y sin ganancia." },
  { title: "Publicar sin estrategia", detail: "Los clientes no llegan." },
  { title: "Confundirte con sabores, tamaños y fechas", detail: "Errores que cuestan caro." },
  { title: "Mes tras mes sin ganancia real", detail: "Mucho esfuerzo, poco resultado." },
];

export const tomos = [
  {
    number: 1,
    short: "Atlas Tortas",
    title: "Atlas de Tortas Rentables",
    description: "5 recetas que venden. Margen 400%+. Cálculo exacto de costos.",
    color: "bg-tomo-navy",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/ec3c7c93-d84f-47a2-8565-7cbe6ad31b4d.jpg",
    imageAlt: "Torta de chocolate en capas con cerezas",
  },
  {
    number: 2,
    short: "Rellenos Pro",
    title: "Arquitectura de Sabores",
    description: "Rellenos pro para clima cálido. Texturas que impactan.",
    color: "bg-tomo-brown",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/66513ad9-2c43-4972-ba61-47b7d6aca08d.jpg",
    imageAlt: "Torta con rellenos de crema y caramelo",
  },
  {
    number: 3,
    short: "Producción",
    title: "Producción en Casa",
    description: "Produce para varias personas desde una cocina pequeña. Tiempos exactos.",
    color: "bg-tomo-green",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/84078759-8cae-4e87-a8d7-f10f786609dc.jpg",
    imageAlt: "Batidora de pedestal plateada",
  },
  {
    number: 4,
    short: "Branding",
    title: "Branding Magnético",
    description: "Identidad visual. Diseño en Canva. Packaging que justifica un precio alto.",
    color: "bg-tomo-purple",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/b61baa45-0d46-422b-aefb-7982b0cb57ae.jpg",
    imageAlt: "Sello dorado con corona y letra R",
  },
  {
    number: 5,
    short: "Ventas",
    title: "Máquina de Ventas",
    description: "50 Reels listos. Meta Ads funcionales. WhatsApp como cierre automático.",
    color: "bg-tomo-orange",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/e958b57d-fc6f-462c-a722-c7bcf162813e.jpg",
    imageAlt: "Gráfico de barras ascendente con flecha",
  },
  {
    number: 6,
    short: "Rentabilidad",
    title: "Master de Rentabilidad",
    description: "Cálculo exacto por porción. Ganancia real. Evita vender a pérdida.",
    color: "bg-tomo-teal",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/d9006a08-e50f-4d90-a345-4717dbf4c6b9.jpg",
    imageAlt: "Calculadora con monedas de oro",
  },
];

export const bonos = [
  { number: 1, title: "Pack 50 Reels Listos", tag: "50 Reels", accent: "bg-bono-red", border: "border-bono-red" },
  { number: 2, title: "Catálogo Maestro en Canva", tag: "Catálogo", accent: "bg-bono-green", border: "border-bono-green" },
  { number: 3, title: "Scripts de Cierre WhatsApp", tag: "Scripts", accent: "bg-bono-orange", border: "border-bono-orange" },
  { number: 4, title: "Agenda y Planificador de Pedidos", tag: "Agenda", accent: "bg-bono-purple", border: "border-bono-purple" },
  { number: 5, title: "Mini-Manual Fotografía Gastronómica", tag: "Fotografía", accent: "bg-bono-navy", border: "border-bono-navy" },
];

export const includes = [
  "6 Tomos completos (420+ páginas)",
  "5 Bonos estratégicos",
  "Plantillas copiables",
  "Recetas testeadas en LATAM",
  "Cálculos exactos de costos",
  "50 Reels listos para publicar",
  "Catálogo en Canva 101",
  "Scripts WhatsApp de cierre",
  "Acceso de por vida",
  "Garantía 7 días",
];

export const hiddenCosts = [
  { label: "4 semanas probando recetas que fracasan", cost: "$200+" },
  { label: "Vender sin ganancia real", cost: "$500+/mes" },
  { label: "Armar un catálogo desde cero", cost: "20 horas" },
  { label: "Meta Ads sin conversiones", cost: "$100+" },
];

export const timeline = [
  { days: "Día 1–5", title: "Acceso + aprendizaje", detail: "Descargas los 6 tomos y eliges tus recetas rentables." },
  { days: "Día 6–15", title: "Primera producción y venta", detail: "Produces, publicas tus Reels y cierras por WhatsApp." },
  { days: "Día 16–30", title: "Sistema en marcha", detail: "Pedidos organizados, precios correctos y clientes recurrentes." },
];
